import { CompanyType } from '@api';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { CompanyFormFields } from './components';
import {
  CompanyFormSchemaType,
  useCompanyFormSchema,
  useUpdateCompany,
} from './hooks';

type EditCompanyFormPropsType = {
  company: CompanyType;
  onClose: () => void;
};

export const EditCompanyForm: React.FC<EditCompanyFormPropsType> = ({
  company,
  onClose,
}) => {
  const { schema, defaultValues } = useCompanyFormSchema(company);
  const { updateCompany } = useUpdateCompany(company.id);

  const methods = useForm<CompanyFormSchemaType>({
    resolver: zodResolver(schema),
    defaultValues,
    values: defaultValues,
  });

  const handleSubmit = async (data: CompanyFormSchemaType) => {
    await updateCompany(data);
    onClose();
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <CompanyFormFields onClose={onClose} />
      </form>
    </FormProvider>
  );
};
